import { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeSanitize from 'rehype-sanitize';
import remarkGfm from 'remark-gfm';
import { formatDateTime } from '../services/date';

const TYPE_BADGE = {
  informational: { label: 'Informational', className: 'border-2 border-blue-500 text-blue-500' },
  maintenance: { label: 'Maintenance', className: 'border-2 border-red-800 text-red-800' },
};

function getTypeBadge(type) {
  const key = (type || 'maintenance').toLowerCase();
  return TYPE_BADGE[key] || TYPE_BADGE['maintenance'];
}

const MaintenancePanel = ({ maintenance, clusterAliasMap = {} }) => {
  const [expanded, setExpanded] = useState({});

  const toggleExpanded = (id) => {
    setExpanded(prev => ({ ...prev, [id]: !prev[id] }));
  };

  const badge = getTypeBadge(maintenance?.type);

  return (
    <div className="bg-gray-300 border border-gray-300 p-4">
      {maintenance && (
        <span className={`text-sm font-bold px-2.5 py-1 rounded-none ${badge.className}`}>
          {badge.label}
        </span>
      )}
      {maintenance ? (
        <div key={maintenance.id} className="mb-4">
          <div className="flex items-center gap-2 mt-1">
            <p className="text-xl font-semibold">{maintenance.title}</p>
          </div>
          <p className="text-sm text-gray-500">
            Scheduled for: {formatDateTime(maintenance.start_time)} {maintenance.ongoing ? '(Ongoing)' : (maintenance.end_time ? <>- {formatDateTime(maintenance.end_time)}</> : '')}
          </p>
          {expanded[maintenance.id] && (
            <div className="prose prose-sm max-w-full mt-2 text-gray-700">
              <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeSanitize]}>{maintenance.most_recent_update}</ReactMarkdown>
            </div>
          )}
          <button onClick={() => toggleExpanded(maintenance.id)} className="text-blue-500 hover:underline mt-2">
            {expanded[maintenance.id] ? 'View Less' : 'View More'}
          </button>
          {maintenance.clusters && maintenance.clusters.length > 0 && (
            <p className="text-sm text-gray-600 mt-2">
              <span className="font-semibold">Affected Clusters:</span> {maintenance.clusters.map(c => clusterAliasMap[c] || c).join(', ')}
            </p>
          )}
        </div>
      ) : (
        <p className="text-gray-700">There are no active notices at this time.</p>
      )}
    </div>
  );
};

export default MaintenancePanel;
